import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { FeatureToggle } from './featureToggles'
import { Permission } from './permissions'

export const insightsPortalDashboardBuilderControl: DomainAccessControlConfig = [
  {
    featureToggles: [FeatureToggle.InsightsDashboardBuilder],
  },
]
